import { Component, OnInit, Input } from '@angular/core';
import { Segment } from '../../../model/segment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-travel-box',
  templateUrl: './travel-box.component.html',
  styleUrls: ['./travel-box.component.css']
})
export class TravelBoxComponent implements OnInit {

  @Input() segments:Segment[];

  constructor(private router:Router) { 

  }

  ngOnInit() {
  }

}
